<template>
  <section :class="siteId">
    <content-area v-if="siteContent" :content="siteContent"></content-area>
  </section>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import contentArea from '@/components/content/content-area.vue';

export default {
  data: () => ({
    siteContent: null,
    siteId: ''
  }),

  computed: {
    ...mapState('companyModule', {
      slug: 'slug'
    })
  },

  async mounted() {
    this.setHeroClaim('');
    const companySlug = this.slug ?? this.$route.params.slug;

    const request = {
      slug: companySlug,
      siteName: this.$route.params.siteName
    };

    const siteResponse = await this.getSite(request);
    const siteData = await siteResponse.json();
    this.siteContent = siteData.content;
    this.siteId = siteData.siteId;

    this.setHeroClaim(siteData.heroClaim ?? '');
    if (siteData.heroImageName) {
      this.setHeroImage(siteData.heroImageName);
    }
  },

  methods: {
    ...mapActions('sitesModule', {
      getSite: 'getSite'
    }),

    ...mapMutations({
      setHeroImage: 'setHeroImage',
      setHeroClaim: 'setHeroClaim'
    })
  },

  components: {
    contentArea
  }
};
</script>
